<!--  ******************************************************  -->
<!--  ADD or UPDATE PRODUCT TYPE DIALOG                           -->
<!--    - Allows the customerProductType to insert or update a ProdType      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
    <h2 mat-dialog-title fxFlex>
        {{'PRODUCT_TYPE.ADD' | translate}}
    </h2>
    <button mat-icon-button color="accent" [mat-dialog-close]="null">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography">

  <div class="matTabGroupContainer" style="max-height: 65vh;">
    <form class="example-form" #putProductType="ngForm">
        <mat-tab-group class="absoluteFill" fxFlexFill>
            <mat-tab label="Dettagli">
                <div style="justify-content: center; display: flex">
                    <div fxLayout="column" fxLayoutGap="15px" style="width: 300px" >
                        <!--  ************************************  -->
                        <!--            PRODUCT_TYPE FIRST NAME             -->
                        <!--  ************************************  -->
                        <mat-form-field class="fullWidthField">
                            <mat-label>{{'PRODUCT_TYPE.NAME' | translate}}</mat-label>
                            <input matInput required #productTypeName="ngModel" type="text" name="productTypeName" [(ngModel)]="data.productType.name">
                            <mat-error *ngIf="productTypeName.invalid">
                                {{'PRODUCT_TYPE.NAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
                            </mat-error>
                        </mat-form-field>
                        <mat-slide-toggle color="primary" name="monitored" (change)="data.productType.moving = data.productType.moving && data.productType.monitored"
                                          [(ngModel)]="data.productType.monitored" fxFlex >
                            {{'PRODUCT_TYPE.MONITORED' | translate}}
                        </mat-slide-toggle>
                        <mat-slide-toggle color="primary" name="ebike"
                                          [(ngModel)]="data.productType.ebike" fxFlex >
                            {{'PRODUCT_TYPE.EBIKE' | translate}}
                        </mat-slide-toggle>
                        <mat-slide-toggle color="primary" name="moving" [disabled]="!data.productType.monitored"
                                          [(ngModel)]="data.productType.moving" fxFlex >
                            {{'PRODUCT_TYPE.MOVEMENT' | translate}}
                        </mat-slide-toggle>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Connettori di Default">
                <table style="padding: 0 !important;"  mat-table [dataSource]="tableDataSource" aria-describedby="product_Types">

                    <!-- Product_Type email Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef width="40%"> Nome </th>
                        <td mat-cell *matCellDef="let element">
                            <span [class]="getConnectorClass(element)">{{element.chargerType.name}}</span>
                        </td>
                    </ng-container>

                    <!-- Product_Type email Column -->
                    <ng-container matColumnDef="power">
                        <th mat-header-cell *matHeaderCellDef width="20%">Potenza</th>
                        <td mat-cell *matCellDef="let element">
                            <span [class]="getConnectorClass(element)">{{element.chargerType.wattPower}}</span>
                        </td>
                    </ng-container>

                    <!-- Product_Type firstname Column -->
                    <ng-container matColumnDef="taIndex">
                        <th mat-header-cell *matHeaderCellDef width="10%">Ta Index</th>
                        <td mat-cell *matCellDef="let element">
                            <input style="width: 5ch !important;" matInput type="number" name="index{{element.chargerType.id}}" [disabled]="element.chargerCount < 1" [(ngModel)]="element.taIndex" min="0" required step="1">
                        </td>
                    </ng-container>

                    <!-- Product_Type lastname Column -->
                    <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef width="10%">Qtà</th>
                        <td mat-cell *matCellDef="let element">
                            <input style="width: 5ch !important;" matInput type="number" name="count{{element.chargerType.id}}" [(ngModel)]="element.chargerCount"  min="0" max="99" required step="1">
                        </td>

                    </ng-container>

<!--                    &lt;!&ndash; Actions Column &ndash;&gt;-->
<!--                    <ng-container matColumnDef="actions">-->
<!--                        <th mat-header-cell *matHeaderCellDef></th>-->
<!--                        <td mat-cell *matCellDef="let element" [ngClass]="(gmService.isMobileScreen() || gmService.isTenantUser()) ? 'smallIcons' : 'normalIcons'">-->
<!--                        </td>-->
<!--                    </ng-container>-->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!--  ************************************  -->
                    <!--               NO DATA ROW              -->
                    <!--  ************************************  -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [colSpan]="displayedColumns.length">{{'COMMON.NO_DATA_FOUND' | translate }}</td>
                    </tr>
                </table>
            </mat-tab>
        </mat-tab-group>
    </form>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
    <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
    <button mat-button class="primaryButton" [disabled]="putProductType.invalid" (click)="saveProductType()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
